import React from 'react';
import { CustomerTaskDtoReadExtended } from '../../customer/model/CustomerTaskDtoRead';
import './TaskSummaryItem.scss';
import { Column, Icon, Row } from '../../components';
import { IconType } from '../../components/components/Icon/interfaces';
import { LookupDetailConstants } from '../../shared/util/LookupDetailConstants';
import ActivityDashboardService from '../activity-dashboard/ActivityDasboardService';
import { setTaskId } from '../TaskDashboardSlice';
import { useDispatch } from 'react-redux';
export interface ITaskSummaryItem {
    taskItem : CustomerTaskDtoReadExtended,
    navigateTo : (path : string) => void
}

export const PolicyIconMapping = {
    [LookupDetailConstants.POLICY_TYPE.HO1] : 'home',
    [LookupDetailConstants.POLICY_TYPE.HO2] : 'home',
    [LookupDetailConstants.POLICY_TYPE.HO3] : 'home',
    [LookupDetailConstants.POLICY_TYPE.HO5] : 'home',
    [LookupDetailConstants.POLICY_TYPE.HO7] : 'home',
    [LookupDetailConstants.POLICY_TYPE.HO8] : 'home',
    [LookupDetailConstants.POLICY_TYPE.HOAHomeowners] : 'home',
    [LookupDetailConstants.POLICY_TYPE.HOBHomeowners] : 'home',
    [LookupDetailConstants.POLICY_TYPE.HOCHomeowners] : 'home',
    [LookupDetailConstants.POLICY_TYPE.MobileHome] : 'home',
    [LookupDetailConstants.POLICY_TYPE.Flood] : 'flood',
    [LookupDetailConstants.POLICY_TYPE.PrivatePassengerAuto] : 'auto',
    [LookupDetailConstants.POLICY_TYPE.UmbrellaP] : 'umbrella',
}

const TaskSummaryItem : React.FunctionComponent<ITaskSummaryItem> = (props) => {

    const dueDateClass = props.taskItem.dueDays < 0 ? "task-summary--due-days--past" : "";

    let activityDashboardService  = new ActivityDashboardService();
    let iconType  = activityDashboardService.getPolicyTypeIcon(props.taskItem.policyTypeId);

    const dispatch = useDispatch();
    
    return <div className='task-summary--main-div'>
            <Row noGutters={true}>
                <Column lg={1} md={1}>
                    <div className='task-summary--icon-div'>
                        <div>
                            {iconType && 
                            <Icon icon={iconType as IconType} 
                                className={'task-summary--item-icon'}
                                title={iconType ? iconType : ''}/>
                            }
                        </div>
                    </div>
                </Column>
                <Column lg={5} md={5}>
                    <div className='task-summary--detail'>
                        <div className='task-summary--customer'>
                            {props.taskItem.custDescr}
                        </div>
                        <div className='task-summary--tasktype'>
                            {props.taskItem.taskTypeDescr}
                        </div>
                    </div>
                </Column>
                <Column lg={3} md={3}>
                    <div className='task-summary--due-date-detail'>
                        <div className='task-summary--due-date'>
                            Due {props.taskItem.dueDaysFormatted}
                        </div>
                        <div className={`task-summary--due-days ${dueDateClass}`}>
                            {props.taskItem.dueDaysDetail}
                        </div>
                    </div>
                </Column>
                <Column lg={2} md={2}>
                    <div className='task-summary--priority-div'>
                        <div className="default-badge-div"><span className={`badge default-badge task-summary--task-badge--priority-${props.taskItem.priorityCode}`}>{props.taskItem.priorityDescr}</span></div>
                    </div>
                </Column>
                <Column lg={1} md={1}>
                    <div className='task-summary--task-screen-arrow-div'>
                        <div>
                            <Icon icon={'right-arrow' as IconType} onClick={() => {
                                dispatch(setTaskId(props.taskItem.id))
                                props.navigateTo(`/customer-view/tasks/${props.taskItem.custId}`)}}
                                className={'task-summary--item-icon'}/>
                        </div>
                    </div>
                </Column>
            </Row>
        </div>;
}

export default TaskSummaryItem